import React, { useState, useEffect } from 'react';
import { WifiSlash, WifiHigh } from '@phosphor-icons/react';

const OfflineStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showStatus, setShowStatus] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowStatus(true);
      setTimeout(() => setShowStatus(false), 3000);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShowStatus(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!showStatus) return null;

  return (
    <div
      id="offline-status"
      className={`fixed top-4 left-4 right-4 z-50 p-4 rounded-lg shadow-lg transition-all duration-300 ${
        isOnline
          ? 'bg-green-500 text-white'
          : 'bg-red-500 text-white'
      }`}
    >
      <div className="flex items-center gap-3">
        {isOnline ? (
          <WifiHigh size={20} weight="bold" />
        ) : (
          <WifiSlash size={20} weight="bold" />
        )}
        <span className="font-medium">
          {isOnline
            ? 'اتصال اینترنت برقرار شد'
            : 'شما در حالت آفلاین هستید'}
        </span>
      </div>
    </div>
  );
};

export default OfflineStatus;
